import { decodeToken } from "react-jwt";
import { getCookie } from "./cookie";

export const SUPER_USER_ROLE = "super_user";

export interface SessionAdmin {
  id: number;
  email: string;
  role?: string;
}

/**
 * The signed-in admin, read straight from the token cookie. Not from redux:
 * AuthContainer fills the store in an effect, after the first render, so a
 * guard reading the store would bounce a super user on every page reload.
 */
export const getSessionAdmin = (): SessionAdmin | null => {
  const token = getCookie();
  if (!token) {
    return null;
  }
  return decodeToken<{ sub?: SessionAdmin }>(token)?.sub ?? null;
};

/**
 * Tokens issued before roles existed have no `role`, so those admins see the
 * Surgo section only after signing in again. The API checks the role on every
 * request anyway; this only decides what to show.
 */
export const isSuperUser = (admin: SessionAdmin | null = getSessionAdmin()): boolean =>
  admin?.role === SUPER_USER_ROLE;

/** "internal_admin" -> "Internal admin" */
export const formatRoleTitle = (title: string | null | undefined): string => {
  if (!title) {
    return "—";
  }
  const words = title.split("_").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};
